//This will allow the user to edit their information

const UserEditComponent = () => {
  return (
    <div>
      <h3>This is the user edit page</h3>
    </div>
  );
};

export default UserEditComponent;
